import { VulnerabilityRow } from '../types';

import { buildNameColumn } from './name';
import { severity } from './severity';
import { counts } from './counts';
import { image } from './image';
import { age } from './age';

export function createColumns(onViewDetails: (row: VulnerabilityRow) => void) {
  return [buildNameColumn(onViewDetails), image, severity, counts, age];
}
